export function lookupSelector<R, S, T>(fnA: (s: S) => R, fnB: (r: R) => T) {
  return function (state: S) {
    return fnB(fnA(state));
  };
}
